import { render, staticRenderFns } from "./ProductCategoriesPage.vue?vue&type=template&id=365b8a2b"
import script from "./ProductCategoriesPage.vue?vue&type=script&lang=js"
export * from "./ProductCategoriesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports